import toast, { Toaster } from "react-hot-toast";

export const darkToast = {
    success: function(msg){
        toast.success(msg, { position: "bottom-center", style: { background: "#222", color: "white", fontSize: "larger" } });
    }
}